.container {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 20px 0;

  .content {
    width: 800px;
    background-color: #eef7f4;
    padding: 20px;
    border-radius: 5px;

    .icon {
      width: 20px;
    }

    .browsers {
      display: flex;
      justify-content: start;
      flex-wrap: wrap;
      margin-top: 15px;
      align-items: center;
      flex-direction: column;

      .browser {
        display: flex;
        justify-content: start;
        align-items: center;
        padding: 0;

        img {
          width: 35px;
          margin-right: 10px;
        }
      }

      div:last-child {
        margin-top: 5px;
      }
    }
  }
}

.start {
  justify-content: start;

  .content {
    width: 720px;
  }

  .browsers {
    display: flex;
    justify-content: start !important;
  }
}

.middle {
  justify-content: center;

  .content {
    text-align: center;
  }
}
